import React, { useEffect, useState } from "react";
import "./Return_order.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import Breadcrumb_comp from "../../../components/common_components/breadcrumb-comp/Breadcrumb_comp";
import Order_details_table from "../cancel_order/order_details_table/Order_details_table";
import Reason_cancelling_field_holder from "../../../components/common_components/reason_cancelling_field_holder/Reason_cancelling_field_holder";
import Select_reason_heading from "../../../components/common_components/select_reason_heading/Select_reason_heading";

import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../../features/order/orderSlice";
import { encodeId, decodeId, formatDate } from "../../../utils/common";
import { getAllCancelReason, getAllReturnReason } from "../../../features/master/masterSlice";

function Return_order() {

  const { id } = useParams()
  const [orderId, setOrderId] = useState(null); // decoded ID

  useEffect(() => {
    if (id) {
      const decoded = encodeId(id);
      setOrderId(decoded);
    }
  }, [id]);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "ORDER DETAILS", link: "/order-details", isActive: false },
    { label: "RETURN ORDER", link: "", isActive: true },
  ];

  const [cancelReason, setCancelReason] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [cancelReasonId, setCancelReasonId] = useState(null);
  const [error, setError] = useState(false);

  const [cancelReasonName, setCancelReasonName] = useState("");
  const dispatch = useDispatch();
  const cancelorder = useSelector((state) => state.order.order);


  useEffect(() => {
    const res = dispatch(getOrder(id));
    if (res.meta?.requestStatus === "fulfilled") {
    } else if (res.meta?.requestStatus === "rejected") {

    }
  }, [dispatch]);


  const reason = useSelector((state) => state.master.returnReasons);
  useEffect(() => {
    // Ensure ID is valid before dispatching
    dispatch(getAllReturnReason());
  }, [dispatch]);
  return (
    <>
      <section className="Return_order">
        <div className=" Return_order_holder">
          <div className="container">
            <div className="title_holder">
              <div className="heading_holder">
                <h4 >
                  <Link to={`/delivered-order/${id}`}>
                    <FontAwesomeIcon className=" arrow_icon me-sm-3 me-2" icon={faCircleChevronLeft} />
                  </Link>{" "}
                  Return Order
                </h4>
              </div>

              <div className="text_holder">
                <h6>{`Order ID #${cancelorder?.invoice_no}`}</h6>
                <h5>{formatDate(cancelorder?.createdAt)}</h5>
              </div>
            </div>


            <Order_details_table
              type="Return"
              setError={setError}
              error={error}
              order={cancelorder}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems} />

            <Select_reason_heading type="Return"
              reason={reason}
              setError={setError}
              error={error}
              cancelReasonId={cancelReasonId}
              setCancelReasonId={setCancelReasonId}
              cancelReasonName={cancelReasonName}
              setCancelReasonName={setCancelReasonName}
            />

            <Reason_cancelling_field_holder
              type="Return"
              setError={setError}
              error={error}
              order={cancelorder}
              cancelReason={cancelReason}
              setCancelReason={setCancelReason}
              selectedItems={selectedItems}
              cancelReasonId={cancelReasonId} />

          </div>
        </div>
      </section>
    </>
  );
}

export default Return_order;
